<template>
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :fill="color"
  >
    <g id="页面-1" stroke="none" stroke-width="1" fill-rule="evenodd">
      <g id="1920-1320安全区" transform="translate(-1842.000000, -811.000000)">
        <g id="侧边栏" transform="translate(1822.000000, 622.000000)">
          <g id="顶部" transform="translate(0.000000, 186.000000)">
            <g id="编组-45" transform="translate(20.000000, 3.500000)">
              <rect id="矩形" fill="#D8D8D8" opacity="0" x="0" y="0" width="24" height="24"></rect>
              <path
                d="M18.4147747,5.99066664 L5.60064692,5.99066664 C4.99950899,5.99066664 4.51161195,5.45672681 4.51161195,4.80422637 C4.51161195,4.15154054 5.00350974,3.61764706 5.60064692,3.61764706 L18.4109691,3.61764706 C19.0120582,3.61764706 19.4999778,4.15154054 19.4999778,4.80422637 C19.5038096,5.45672681 19.0120582,5.99066664 18.4147747,5.99066664 Z M19.2266841,13.9404375 L13.2743403,8.096809 C12.5443975,7.49988095 11.4632177,7.49988095 10.7372757,8.096809 L4.78112627,13.9404375 C4.601385,14.1444656 4.5038056,14.3964648 4.5,14.6635274 C4.51561271,15.3198284 5.08928204,15.8388903 5.78014424,15.8240586 L7.56784777,15.8240586 C7.9268912,15.8092269 8.22743577,16.0688274 8.24709802,16.4099556 L8.24709802,19.1463509 C8.25090362,19.8287 8.83257447,20.3810868 9.55071011,20.3810868 L14.4881793,20.3810868 C15.1595744,20.4107964 15.7216318,19.9139821 15.752906,19.2799749 L15.752906,16.4247873 C15.7567116,16.0837054 16.0494498,15.8130275 16.4084933,15.8166428 L18.1376979,15.8166428 C18.8285601,15.8760158 19.4374556,15.393894 19.4999553,14.7377784 L19.4999553,14.6486957 C19.4999553,14.3816331 19.3983751,14.1258333 19.2188778,13.9219443 L19.2266841,13.9404375 Z"
                id="Fill-1"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: String,
  },
  components: {},
  data() {
    return {}
  },

  mounted() {},

  methods: {},
}
</script>

<style lang="less" scoped></style>
